export const appHead = {"meta":[{"charset":"utf-8"},{"property":"og:site_name","content":"WN Hub"},{"name":"twitter:card","content":"summary_large_image"},{"name":"viewport","content":"width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=no, viewport-fit=cover"}],"link":[{"rel":"preconnect","href":"https://resizer.wnhub.io"},{"rel":"preconnect","href":"https://cdn.wnhub.io"},{"rel":"preconnect","href":"https://cdn2.wnhub.io"}],"style":[],"script":[{"innerHTML":"\n;(function(){\n  try {\n    var elements = document.querySelectorAll('[data-src]');\n    var interactionCount = 0;\n\n    if (!('IntersectionObserver' in window)) {\n      console.warn('IntersectionObserver not supported, loading all assets immediately.');\n      for (var i = 0; i < elements.length; i++) {\n        load(elements[i]);\n      }\n      return;\n    }\n    \n    function load(element) {\n      try {\n        var dataSrc = element.getAttribute('data-src');\n        if (dataSrc && element.src !== dataSrc) {\n          element.src = dataSrc;\n        }\n      } catch (err) {\n        console.error('Error loading element:', err);\n      }\n      observer.unobserve(element);\n    }\n    \n    var observer = new IntersectionObserver(function (entries) {\n      for (var i = 0; i < entries.length; i++) {\n        var entry = entries[i];\n        if (entry.isIntersecting) {\n          load(entry.target);\n        }\n      }\n    }, {\n      threshold: 0\n    });\n    \n    for (var i = 0; i < elements.length; i++) {\n      try {\n        observer.observe(elements[i]);\n      } catch (err) {\n        console.error('Error observing element:', err);\n      }\n    }\n    \n    function onInteraction() {\n      interactionCount++;\n      if (interactionCount >= 5) {\n        console.log('perf: force lazy load on interaction');\n        for (var i = 0; i < elements.length; i++) {\n          try {\n            load(elements[i]);\n          } catch (err) {\n            console.error('Error during forced load:', err);\n          }\n        }\n        window.removeEventListener('scroll', onInteraction);\n        window.removeEventListener('pointermove', onInteraction);\n        window.removeEventListener('keydown', onInteraction);\n      }\n    }\n    \n    window.addEventListener('scroll', onInteraction, { passive: true });\n    window.addEventListener('pointermove', onInteraction, { passive: true });\n    window.addEventListener('keydown', onInteraction);\n  } catch (error) {\n    console.error('Error in lazy load script:', error);\n  }\n})();\n","tagPosition":"bodyClose"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false